/** @module Chat */
define([
], function() {

	return {
		
	};
});
